export default class UpgradeSourceController {
  /*@ngInject*/
  constructor($scope, $location, installerResource, fields, wizardInfo, refreshWizardInfo, oldUpgradeManager) {
    this.$scope = $scope;
    this.$location = $location;
    this.fields = fields;
    this.wizardInfo = wizardInfo;
    this.installerResource = installerResource;
    this.oldUpgradeManager = oldUpgradeManager;
    this.refreshWizardInfo = refreshWizardInfo;

    this.checkPathResource = installerResource.checkUpgradeSourcePath;

    this.upgradeSource = installerResource.upgradeSource.get();

    if (this.isIncompatibleInstallationDetected()) {
      this.verifyIncompatiblePath(this.upgradeSource);
    }

    this.upgradeSourceDefault = installerResource.upgradeSourceDefault.get();
  }

  nextStep() {
    this.installerResource.clearSingletonOf('upgradeSettings');

    delete this.errors;
    this.isSaving = true;
    this.upgradeSource.$save().
      then(() => this.refreshWizardInfo()).
      then(() => this.installerResource.clearSingletonOf('licenseSettings')).
      then(() => this.$location.url('upgrade/settings')).
      catch(response => {
        if (response) {
          this.errors = this.installerResource.extractErrorMessage(response.data);
        }
      }).
      finally(() => {
        this.isSaving = false;
      });
  }

  discardAndInstall() {
    this.oldUpgradeManager.manageExistUpgrade(true).
      then(() => this.refreshWizardInfo()).
      then(() => this.$location.path('/install/base'));
  }

  verifyIncompatiblePath(resource) {
    resource.$promise.
      then(() => resource.$save()).
      catch(response => {
        this.errors = {
          upgradeSourceIncompatible: this.installerResource.extractErrorMessage(response.data)[this.fields.UPGRADE_SOURCE_LOCATION].error_description
        };
      });
  }

  onKeyPress($event) {
    if ($event.which === 13) {
      if (!this.isNextDisabled()) {
        this.nextStep();
      }
    }
  }

  isBackupMeansArchive() {
    return this.wizardInfo.productName !== 'Upsource';
  }

  getDiscardDetectedHint() {
    return 'If you want to perform a clean installation, you can discard the settings stored in the selected data directory location. You will be prompted to create a backup of the previous installation.';
  }

  isNextDisabled() {
    return !this.upgradeSource[this.fields.UPGRADE_SOURCE_LOCATION] ||
      this.isSaving || this.$scope.upgradeSourceForm.$invalid;
  }

  checkPathAccess(path, property) {
    const type = this.upgradeSource[this.fields.UPGRADE_TYPE];
    return this.checkPathResource.get({property, path, type}).$promise;
  }

  getErrorMessage(field) {
    if (this.errors) {
      const error = this.errors[field];
      return error ? error.error_description : error;
    }
  }

  isIncompatibleInstallationDetected() {
    return this.wizardInfo.isUpgradeDetected && !this.wizardInfo.isDetectedUpgradeSourceValid;
  }

  getMinimalCompatible() {
    const minVersion = this.upgradeSource[this.fields.UPGRADE_MINIMAL_COMPATIBLE];
    return minVersion ? `(${minVersion} or later)` : '';
  }

  getBackupDescription() {
    if (this.wizardInfo.productName !== 'Upsource') {
      return null;
    }
    const productName = this.wizardInfo.productName;
    const newVersion = this.wizardInfo.productFullVersion;

    return `The database in the backup copy will be re-indexed to support ${productName} ${newVersion}, 
    which will take some time. If your backup database is compatible with ${productName} ${newVersion} ${this.getMinimalCompatible()}, 
    do not use this option. Your previous installation is already indexed and ready 
    for use with ${productName} ${newVersion}. Select a previous installation as the upgrade source.`;
  }
}



// WEBPACK FOOTER //
// ./src/pages/upgrade-source/upgrade-source__controller.js